/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/

export const formatFileSize = (bytes) => {
  if (bytes === null || bytes === undefined || bytes === '') { return '—'; }
  const num = Number(bytes);
  if (isNaN(num)) { return '—'; }
  if (num < 1024) { return `${num} B`; }
  if (num < 1024 * 1024) { return `${(num / 1024).toFixed(1)} KB`; }
  return `${(num / (1024 * 1024)).toFixed(1)} MB`;
};
